module.exports = __webpack_public_path__ + "img/tools-settings.5131bccc.png";